var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarSparkle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.634,
    height: 31.556,
    viewBox: "0 0 32.634 31.556",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "9310114_star_sparkle_stars_sparkles_icon"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 91671",
    d: "M12.853 5.849A12.4 12.4 0 0 1 0 18.705a12.4 12.4 0 0 1 12.853 12.852 12.4 12.4 0 0 1 12.854-12.852A12.4 12.4 0 0 1 12.853 5.849z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 91672",
    d: "M25.905 0a6.492 6.492 0 0 1-6.729 6.725 6.492 6.492 0 0 1 6.729 6.729 6.492 6.492 0 0 1 6.729-6.729A6.492 6.492 0 0 1 25.905 0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSparkle);
export default __webpack_public_path__ + "static/media/star_sparkle.svg";
export { ForwardRef as ReactComponent };